import { registerComponent } from "helpers";
import WYATTElement from "wyatt";
import StoreTaxInfo from "store-tax-info";

registerComponent(
  "tax-notice",
  class TaxNotice extends WYATTElement {
    constructor() {
      super();

      this.storeTaxInfo = new StoreTaxInfo();
      this.onPreferredStoreChange = this.handlePreferredStoreChange.bind(this);
      this.onStoresFetched = this.handleStoresFetched.bind(this);
    }

    connectedCallback() {
      this.config = this.getComponentConfig();

      this.updateVisibility();

      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.onPreferredStoreChange,
      );

      this.subscribe(WYATT.PubSub.events.storesFetched, this.onStoresFetched);
    }

    handlePreferredStoreChange(store) {
      this.updateVisibility(store);
    }

    handleStoresFetched() {
      this.updateVisibility();
    }

    async updateVisibility(storeOverride) {
      const { productGroupId } = this.config;
      const store = storeOverride ?? WYATT.PreferredStores?.store;

      if (!productGroupId || !store) {
        this.hidden = true;

        return;
      }

      try {
        const isTaxable = await this.storeTaxInfo.isProductTaxableAtStore(
          productGroupId,
          store,
        );

        this.hidden = !isTaxable;
      } catch {
        this.hidden = true;
      }
    }
  },
);
